import noop from 'lodash/noop';

import { CorrelatedLogger, LogLevel, Logger } from '@eluve/logger';

export const logMessage = (
  machine: { context: { logger: Logger } },
  params: {
    level: LogLevel;
    message: string;
    logMeta?: Record<string, unknown>;
  },
) => {
  const {
    context: { logger },
  } = machine;
  const { level, message, logMeta = {} } = params;
  logger[level](message, logMeta);
};

export type LogAction = (
  _: unknown,
  params: {
    level: LogLevel;
    message: string;
    logMeta?: Record<string, unknown>;
  },
) => void;

/**
 * A no-op log action to allow pluggable logging in machines that don't depend
 * on a specific logger
 */
export const logAction: LogAction = () => {
  noop();
};

export const createDefaultLogActionFromLogger = (logger: Logger): LogAction => {
  return (_, params) => {
    const { level, message, logMeta = {} } = params;
    logger[level](message, logMeta);
  };
};

export const createDefaultLogActionFromCorrelatedLogger = (
  correlatedLogger: CorrelatedLogger,
): LogAction => {
  return (_, params) => {
    const { level, message, logMeta = {} } = params;
    correlatedLogger(level, message, logMeta);
  };
};
